export default __webpack_public_path__ + "static/partners-1f12c0960c38598619be6115edcbda27.jpg";